import { useEffect } from "react";

export default function useEffectOnce(callback: () => (() => void) | void) {
    useEffect(() => {
        callback();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
